import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next';
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import DoctorHome from './DoctorHome';


export default function DoctorList() {
    const { t } = useTranslation();
    return (
        <Fragment>            
            <Breadcrumbs mainTitle={t("List of Doctors")} parent={t("Home")} title={t("List of Doctors")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                    <DoctorHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
